import 'events-polyfill';
import GameListeners from "./game";
import WebListeners from "./web";
import { constants } from "../constants"

export default class Listeners {
    constructor(gb) {
        Object.assign(this, { gb });

        this.gameListeners = new GameListeners(gb);

        if (gb.utils.isIframe === true) {
            this.webListeners = new WebListeners(gb);
        }

        if (this.gb.settings.nativeMobileApp === true && this.gb.walletCode === 'PLAYTECH') {
            this.webListeners = new WebListeners(gb);
        }

        window.addEventListener("message", (e) => {
            this.handleMessage(e)
        });
    }

    handleMessage(e) {
        // logger.debug("Raw message", e);
        let payload = e.data;

        // try if object
        if (typeof payload === "string") {
            try {
                payload = JSON.parse(payload);
            } catch (e) {
                // not an object
            }
        }

        if (this.ignoreMsg(payload) === true) {
            return;
        }

        if (payload.handled === true) {
            return;
        }

        // TODO refactor
        let msgDirection = "WEB2GAME";

        if ((this.gb.gameIframe.contentWindow === e.source || this.gb.gameIframe.src.indexOf(e.origin) === 0) && this.gb.walletCode !== 'POKERSTARS' && this.gb.walletCode !== 'PLAYTECH') {
            msgDirection = "GAME2WEB";
        } else if (((this.gb.gameIframe.contentWindow === e.source || this.gb.gameIframe.src.indexOf(e.origin) === 0) && (this.gb.walletCode === 'POKERSTARS' || this.gb.walletCode === 'PLAYTECH') && !this.gb.settings.nativeMobileApp)) {
            msgDirection = "GAME2WEB";
        } else if (this.gb.gameIframe.contentWindow === e.source && (this.gb.walletCode === 'POKERSTARS' || this.gb.walletCode === 'PLAYTECH') && this.gb.settings.nativeMobileApp) {
            msgDirection = "GAME2WEB";
        } else if (window === e.source && payload && payload['integration_player_notifications'] && payload['walletProviderCode'] === 'POKERSTARS') {
            msgDirection = "GAME2WEB";
        } else if (window === e.source && payload && payload['integration_player_notifications'] && payload['walletProviderCode'] === 'PLAYTECH') {
            msgDirection = "GAME2WEB"; 
        } else if (typeof this.gb.gameIframe.contentWindow === "object" && Object.keys(this.gb.gameIframe.contentWindow).length > 0 && this.gb.settings.gameProviderCode === 'NEXTGEN') {
            // if gameIframe containes multiple iframes, example Nextegen
            if (Object.values(this.gb.gameIframe.contentWindow).some(value => value === e.source)) {
                msgDirection = "GAME2WEB";
            }
        } else if (this.gb.walletCode === 'PLAYTECH' && this.gb.settings.nativeMobileApp && this.gb.gameIframe.src.indexOf(e.origin) === 0 && this.gb.gameIframe.contentWindow === e.source) {
            msgDirection = "GAME2WEB";
        }

        // a small hack to make sure we don't mess something on production ... this is needed for Mock RGS deployed clients to use GB integration
        // EXAMPLE: https://prodcopy-services.oryxgaming.com/games/ASL/ASL_FTL_EU/stg/iframe.html?mock=true
        if (this.gb.settings.internalUseOnly === true) {
            try {
                if (e.source.location.href === window.parent.location.href) {
                    msgDirection = "WEB2GAME";
                }
            } catch (e) {
                // probably CORS issues ... so it is not web msg
            }
        }

        // if there is not parent (is not iframe), then GB is on top level and the incoming WEB2GAME msg is its own, triggered in emitters as a response to GAME2WEB msg ...
        // without this IF here, GB would receive this msg, would not have listener for it and would trigger it back to game with "gameBridgePassthru": true ... this can cause a loop in some cases
        if (this.gb.utils && this.gb.utils.isIframe !== true && msgDirection === "WEB2GAME" && !this.gb.passThrough2Playtech && (this.gb.walletCode !== 'PLAYTECH' && !this.gb.settings.nativeMobileApp)) return;


        let action = null;
        if (typeof payload === "string") {
            if (this.gb.gameProviderProtocol === constants.GREENTUBE) {
                // greentube uses 2 types of messages ... string ("SOUND:FALSE", "GAME_MODE:LOADING", "LOADING_PROGRESS:100", ...) and json ('{"event":{"name":"loadingProgress","value":100}}')
                // currently their games use both type of msgs (wrapper protocol v1 and v2) but string msgs will get removed in the future, so Oryx Game Bridge will implement only protocol v2 (json msgs)

                // but ... since protocol 2 is lacking some basic msgs ... we need to have this hack here ... remove in the future when protocol 2 will be fully implemented per specs ... (Saso 2020-08-06)
                if (payload.indexOf("OPENSHOP") === 0) { // can have trailing : ... "OPENSHOP:"
                    payload = "cashier"; // default event
                } else if (payload.indexOf("TOOLITTLEMONEY") === 0) { // can have trailing : ... "TOOLITTLEMONEY:"
                    payload = "errorOutOfMoney"; // default event
                } else {
                    logger.debug(`Ignoring GreenTube Wrapper protocol v1 msg: ${payload}`);
                    return;
                }
            }
            action = payload;
        } else if (payload.wpgaction) {
            action = payload.wpgaction;
        } else if (payload.message) {
            action = payload.message;
        } else if (payload.msg) {
            action = payload.msg;
        } else if (payload.event) {
            action = payload.event;
        } else if (payload.action) {
            action = payload.action;
        } else if (payload.type && this.gb.gameProviderProtocol !== "EDIG") {
            action = payload.type;
        } else if (payload.name) {
            action = payload.name;
        } else if (payload.Name) {
            action = payload.Name;
        } else if (payload.method) {
            action = payload.method;
        } else if (payload.rgMessage) {
            action = payload.rgMessage;
        } else if (payload.gcmevent) {
            action = payload.gcmevent;
        } else if (payload. eventid) {
            action = payload.eventid;
        } else if (payload.command) {
            action = payload.command;
        } else if (payload.eventType) {
            action = payload.eventType;
        } else if (payload._type) {
            action = payload._type;
        } else if (payload.msgId) {
            action = payload.msgId;
        } else if (payload.messageId) {
            action = payload.messageId
        } else if (payload.eventName) {
            action = payload.eventName
        } else if (payload.exi_fMessageType_str){
            action = payload.exi_fMessageType_str;
        }

        if (this.gb.gameProviderProtocol === constants.GREENTUBE) {
            if (payload.event) {
                action = payload.event.name;
            }
            if (payload.state) {
                action = payload.state.name;
            }
            if (payload.config) {
                action = payload.config.name;
            }
            if (payload.error) {
                action = payload.error.name;
            }
        }

        if (this.gb.walletCode === constants.INTRALOT && action === "gameConfigReceived") {
            this.gb.gameConfigReceived = true;
        }

        if (this.gb.rgsProtocol === constants.NETEBLUE ||
            this.gb.rgsProtocol === constants.NETENETE) {
            // all messages are processed in addIframeNETEBLUE function
            return;
        }

        logger.info(msgDirection, action, payload);

        // logging payload should be done before payload mapping because logger uses json.stringify
        // and this method doesn't support stringifiying global object

        if (this.gb.gameProviderProtocol === constants.NEXTGEN || this.gb.gameProviderProtocol === constants.NYXNEXTGEN) {
            payload = {
                data: e.data,
                origin: e.origin,
                source: e.source
            }
        }

        if (this.gb.gameProviderProtocol === "EVOLUTION" || this.gb.gameProviderProtocol === "EVOL") {
            const regex = new RegExp(/:(.*)/)
            const evolAction = regex.test(action) ? regex.exec(action)[1] : action;
            action = evolAction;

            payload = e.data ? { data: e.data, source: e.source } : null;
        }

        if (this.gb.gameProviderProtocol === "DGC") {
            payload = e.data && e.target.origin ? { data: e.data, target: e.target.origin } : { data: e.data };
        }

        // overwrite actionParser
        if (this.gb.settings.overwrite && this.gb.settings.overwrite.actionParser && typeof this.gb.settings.overwrite.actionParser === "function") {
            action = this.gb.settings.overwrite.actionParser(payload);

            logger.info("using custom action parser, action: ", action);

            if (!action || typeof action !== "string") {
                // alert("Could not parse action from 'actionParser' function provided in 'overwrite' object. Function should return a string! Check console for more data!");
                logger.error("Could not parse action from 'actionParser' function provided in 'overwrite' object. Function should return a string - you are returning:", action);
            }
        }

        // if (this.gb.gameProviderCode === 'GAM' && action === 'balance.parent') {
        //     return;
        // }


        if (action && typeof action === "string") {
            if (action.indexOf(".parent") > -1) {
                logger.debug("'.parent' found in action.", action);
                action = action.replace(".parent", "");
                logger.debug("removing '.parent' from action. New action: ", action);
            }

            if (msgDirection === "GAME2WEB") {
                // check overwrites
                if (this.gb.settings && this.gb.settings.overwrite && this.gb.settings.overwrite.listners && this.gb.settings.overwrite.listners.game) {
                    if (this.gb.settings.overwrite.listners.game.hasOwnProperty(action) && typeof this.gb.settings.overwrite.listners.game[action] === "function") {
                        logger.info("found " + msgDirection + " listener OVERWRITE for action: ", action);
                        this.gb.settings.overwrite.listners.game[action](this.gb, payload);
                        return;
                    }
                }

                // game to web
                if (this.gameListeners[action] !== undefined) {
                    logger.info("found " + msgDirection + " listener for action: ", action);
                    this.gameListeners[action](payload);
                    return;
                }
            } else {
                // check overwrites
                if (this.gb.settings && this.gb.settings.overwrite && this.gb.settings.overwrite.listners && this.gb.settings.overwrite.listners.web) {
                    if (this.gb.settings.overwrite.listners.web.hasOwnProperty(action) && typeof this.gb.settings.overwrite.listners.web[action] === "function") {
                        logger.info("found " + msgDirection + " listener OVERWRITE for action: ", action);
                        this.gb.settings.overwrite.listners.web[action](this.gb, payload);
                        return;
                    }
                }
                // web to game
                if (this.webListeners && this.webListeners[action] !== undefined) {
                    logger.info("found " + msgDirection + " listener for action: ", action);
                    this.webListeners[action](payload);
                    return;
                }
            }
        }

        // no listener found
        logger.info("no " + msgDirection + " listener for action:", action);

        if (msgDirection === "GAME2WEB") {
            // because e.source has window methods, CORS policy
            if (payload && payload.source) {
                delete payload['source']
            }

            //passThrough2Playtech is for combo Playtech wallet + SPIN games
            if (this.gb && this.gb.passThrough2Playtech && !payload.handled) {
                payload.handled = true;
                payload = JSON.stringify(payload);
                this.gb.emitters.emit.web.passthru(payload);
            } else if (!payload.handled) {
                this.gb.emitters.emit.web.passthru(payload);
            }

        } else {
            // because e.source has window methods, CORS policy
            if (payload && payload.source) {
                delete payload['source']
            }

            //passThrough2Playtech is for combo Playtech wallet + SPIN games
            if (this.gb && this.gb.passThrough2Playtech && !payload.handled) {
                payload.handled = true;
                payload = JSON.stringify(payload);
                this.gb.emitters.emit.game.passthru(payload);
            } else if (!payload.handled) {
                this.gb.emitters.emit.game.passthru(payload);
            }
        }
    }

    ignoreMsg(payload){
        if (typeof payload === "string") {
            if (payload.indexOf("webpack") > -1 || payload === 'undefined') {
                return true;
            }
        }

        let ignoreMsgs = ["webpackInvalid","webpackOk","webpackProgress"];
        try {
            if (payload.type && (ignoreMsgs.indexOf(payload.type) > -1 || payload.type.indexOf("webpack") > -1)) {
                return true;
            }
        } catch (e) {
            // console.warn("error", e);
        }

        return false;
    }
}
